/**
 * @generated SignedSource<<7ebaff8e3c18ba8caaa3a7c5449bc121>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import type { ReaderFragment } from 'relay-runtime';
import type { FragmentRefs } from "relay-runtime";
export type HeaderSubIssueSummary$data = {
  readonly subIssues?: {
    readonly nodes: ReadonlyArray<{
      readonly closed: boolean;
    } | null | undefined> | null | undefined;
  };
  readonly subIssuesConnection?: {
    readonly totalCount: number;
  };
  readonly subIssuesSummary?: {
    readonly completed: number;
    readonly total: number;
  };
  readonly " $fragmentType": "HeaderSubIssueSummary";
};
export type HeaderSubIssueSummary$key = {
  readonly " $data"?: HeaderSubIssueSummary$data;
  readonly " $fragmentSpreads": FragmentRefs<"HeaderSubIssueSummary">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [
    {
      "defaultValue": false,
      "kind": "LocalArgument",
      "name": "fetchSubIssues"
    }
  ],
  "kind": "Fragment",
  "metadata": null,
  "name": "HeaderSubIssueSummary",
  "selections": [
    {
      "condition": "fetchSubIssues",
      "kind": "Condition",
      "passingValue": false,
      "selections": [
        {
          "alias": null,
          "args": null,
          "concreteType": "SubIssuesSummary",
          "kind": "LinkedField",
          "name": "subIssuesSummary",
          "plural": false,
          "selections": [
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "total",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "completed",
              "storageKey": null
            }
          ],
          "storageKey": null
        }
      ]
    },
    {
      "condition": "fetchSubIssues",
      "kind": "Condition",
      "passingValue": true,
      "selections": [
        {
          "alias": "subIssuesConnection",
          "args": null,
          "concreteType": "IssueConnection",
          "kind": "LinkedField",
          "name": "subIssues",
          "plural": false,
          "selections": [
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "totalCount",
              "storageKey": null
            }
          ],
          "storageKey": null
        },
        {
          "alias": null,
          "args": [
            {
              "kind": "Literal",
              "name": "first",
              "value": 100
            }
          ],
          "concreteType": "IssueConnection",
          "kind": "LinkedField",
          "name": "subIssues",
          "plural": false,
          "selections": [
            {
              "alias": null,
              "args": null,
              "concreteType": "Issue",
              "kind": "LinkedField",
              "name": "nodes",
              "plural": true,
              "selections": [
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "closed",
                  "storageKey": null
                }
              ],
              "storageKey": null
            }
          ],
          "storageKey": "subIssues(first:100)"
        }
      ]
    }
  ],
  "type": "Issue",
  "abstractKey": null
};

(node as any).hash = "d9f5d421b307a8d4fa4358dadc8ad475";

export default node;
